export default __webpack_public_path__ + "static/media/icon-copy-outline-white.0f26fbf7.svg";